'use client';
import { useEffect, useState } from 'react';
import { ProductDetailType } from '@/lib/type/home-data.type';
import ProductDataShow from '@/app/product/ProductUp';
import ProductImageShow from '@/app/product/ProductDown';
import { Breadcrumb, Empty } from 'antd';
import Loading from '@/components/loading';
import ProductTSelection2 from '../TypeSelection/ProductTSelection2';
type Props = {
  data?: ProductDetailType;
  category?: any;
};
interface ParentCategory {
  title: string;
  slug: string;
  id: string;
}

const ProductLayout: React.FC<Props> = ({ data, category }) => {
  let [types, settypes] = useState<string[]>([]);
  const iframeSrc = data?.name
    ? `https://www.bocangku.com/vendor/djcd/part/selector?prodName=${encodeURIComponent(data?.name || '')}&language=zh-cn`
    : '';
  const iframeSrc2 = data?.name
    ? `https://www.bocangku.com/vendor/djcd/part/model?prodName=${encodeURIComponent(data?.name || '')}&language=zh-cn&datasheet=true&collect=true`
    : '';
  // console.log({iframeSrc2}, 'iframeSrc2');
  let [BreadcrumbData, setBreadcrumbData] = useState<ParentCategory[]>([]);
  // 当前产品详情页商品
  const [currentProduct, setCurrentProduct] = useState<ProductDetailType>();
  const [NotFoundProduct, setNotFoundProduct] = useState(false);
  const [loading, setLoading] = useState(false);

  //对应的数据
  const [embedPartNumberData, setEmbedPartNumberData] = useState<any | null>(null);
  const [embedPartNumberDataMap, setEmbedPartNumberDataMap] = useState<any | null>({});
  // 获取分类层级的函数
  const getCategoryLevels = (categoryId: string | undefined) => {
    if (!categoryId) return;
    const result: any[] = [];

    // 查找二级分类 - 遍历所有分类
    for (const parentCategory of category) {
      // 在子分类中查找
      const childCategory = parentCategory?.child?.find(
        (item: any) => item.id === categoryId
      );
      if (childCategory) {
        // 如果找到二级分类，添加一级分类和二级分类

        result.push({
          title: parentCategory.title,
          href: parentCategory.slug,
          id: parentCategory.id,
        });
        result.push({
          title: childCategory.title,
          href: childCategory.slug,
          id: childCategory.id,
        });
        return result;
      }
    }

    // 如果没找到二级分类，查找一级分类
    const parentCategory = category.find((item: any) => item.id === categoryId);
    if (parentCategory) {
      result.push({
        title: parentCategory.title,
        href: parentCategory.slug,
        id: parentCategory.id,
      });
      return result;
    }

    return result;
  };

  const getProduct = async () => {
    setCurrentProduct(data);
    let arr = getCategoryLevels(data?.cate_id);

    if (arr?.length) {
      setBreadcrumbData([
        {
          title: 'Home',
          href: '/',
          id: '0',
        },
        ...arr,
      ]);
    }

    setLoading(false);
  };


  // 初始化 embedPartNumberDataMap，确保下拉选择时能正确映射
  useEffect(() => {
    if (!data?.sku?.length) return;
    const dataMap: Record<string, any> = {};
    data.sku.forEach((item: any) => {
      dataMap[item?.name] = item;
    });
    setEmbedPartNumberDataMap(dataMap);
    console.log(dataMap, "dataMap");

  }, [data?.sku]);


  // 监听国创内嵌页选型变化 postMessage: { action: 'updateModel', partNumber: string }
  // 依赖 embedPartNumberDataMap，确保 message 回调里读到的是已从 data.sku 初始化好的 map，避免闭包拿到空对象
  useEffect(() => {
    getProduct();
    const handler = (event: MessageEvent) => {
      if (event.origin !== 'https://www.bocangku.com') return;
      const payload = event.data;
      console.log(payload, "发送的");
      if (payload?.action === 'updateModel') {
        const pn = payload.partNumber;
        const isEmpty = pn == null || String(pn).trim() === '';
        // console.log(isEmpty, "isEmpty");
        if (isEmpty) {
          setEmbedPartNumberData(() => null);
        } else {
          changeEmbedPartNumberData(payload.partNumber);
        }
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [embedPartNumberDataMap]);

  //修改对应的数据
  function changeEmbedPartNumberData(name: string) {
    setEmbedPartNumberData(embedPartNumberDataMap[name]);
    console.log(embedPartNumberDataMap[name], "赋值对象",name);

  }
  // 重置
  function resetEmbedPartNumberData() {
    setEmbedPartNumberData(() => null);
  }

  return (
    <div className="bg-[#f5f7fa] pt-6 pb-20">
      <div className={`container pb-3`}>
        {
          BreadcrumbData.length > 0 && <Breadcrumb
          // @ts-ignore
            items={BreadcrumbData}
          />
        }

      </div>
      <div>
        {NotFoundProduct ? (
          <div className="c-flex">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span className="text-xl">该商品不存在或已下架</span>
              }
            ></Empty>
          </div>
        ) : (
          <div>
            {loading ? (
              <Loading />
            ) : (
              <>
                {/* 第一部分 */}
                <div className={`container flex items-stretch gap-x-6`}>
                  <div className="h-auto shrink-0 bg-white">
                    {/* sticky：顶对齐视口，随左列（被 flex 拉伸与右侧同高）结束而结束；overflow 放在内层避免影响 sticky */}
                    <div className="sticky top-0 z-10 ">
                      <div className="overflow-hidden">
                        {iframeSrc ? (
                          <iframe
                            src={iframeSrc}
                            className="w-full h-[900px]"
                            title="国创零部件库-选型器"
                          />
                        ) : (
                          <div className="flex h-[500px] w-full items-center justify-center bg-[#fafafa] text-[#999]">
                            暂无选型器数据
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='flex-1 '>
                    <ProductDataShow embedPartNumberData={embedPartNumberData} resetEmbedPartNumberData={resetEmbedPartNumberData} changeEmbedPartNumberData={changeEmbedPartNumberData} types={types} product={data} currentProduct={currentProduct} />
                    {/* 详情 */}
                    <ProductTSelection2
                      iframeSrc2={iframeSrc2}
                      product={data}
                    />
                  </div>
                </div>
              </>

            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default ProductLayout;
